import React from "react";
import { Spinner } from "@/components/ui";
import { EmbedSnippet } from "../../components/EmbedSnippet";
import { MOBILE_PREVIEW_WIDTH, PreviewDevice } from "../../components/usePreviewPlayer";
import { EMBED_IFRAME_HEIGHT } from "./useReviewWidgetPreview";

interface Props {
  iframeRef: React.RefObject<HTMLIFrameElement>;
  iframeSrc: string;
  includeAutoResize: boolean;
  iframeHeight: number;
  previewDevice: PreviewDevice;
  isLoading: boolean;
  previewPlayerName?: string;
  iframeSnippet: string;
}

const ReviewWidgetPreview: React.FC<Props> = ({
  iframeRef,
  iframeSrc,
  includeAutoResize,
  iframeHeight,
  previewDevice,
  isLoading,
  previewPlayerName,
  iframeSnippet,
}) => {
  const isMobilePreview = previewDevice === "mobile";
  const previewHeight = includeAutoResize ? iframeHeight : EMBED_IFRAME_HEIGHT;

  return (
    <div className="min-w-0 w-full overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
      <div className="relative min-w-0 w-full">
        <iframe
          key={iframeSrc}
          ref={iframeRef}
          title="Review Widget preview"
          src={iframeSrc}
          className={`block border-0 bg-white ${isMobilePreview ? "mx-auto" : "w-full"}`}
          style={{
            height: previewHeight,
            ...(isMobilePreview ? { width: MOBILE_PREVIEW_WIDTH, maxWidth: "100%" } : undefined),
          }}
        />
        {isLoading && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 bg-white">
            <Spinner className="size-6 text-slate-500" />
            <p className="text-sm text-slate-500">Loading {previewPlayerName || "player"} preview…</p>
          </div>
        )}
      </div>

      <EmbedSnippet label="Iframe snippet" snippet={iframeSnippet} />
    </div>
  );
};

export { ReviewWidgetPreview };
